import Base from './base'

export default class PausePeople extends Base {
  async get(endpoint: string, personId: number) {
    const result = await this.api.get(endpoint, { params: { person_id: personId } })
    return result.data
  }
}
